import { Effect, EffectParams } from './Effect';
import { EffectFunc, EffectFuncParams, EffectsLayer } from './EffectsLayer';

export const EffectStackState = {
  Ready: 'ready',
  Showing: 'showing',
  Updating: 'updating',
  Hiding: 'hiding',
  Hidden: 'hidden'
} as const;
export type EffectStackStateKeys = keyof typeof EffectStackState;
export type EffectStackStateValues = typeof EffectStackState[EffectStackStateKeys];

export interface EffectStackParams {
  state: EffectStackStateValues;
  targets: Effect[];
  endPoints: number[][];
  effects: { function: EffectFunc; params?: EffectFuncParams }[];
  effectSetup?: (effect: EffectParams) => void;
  effectParams?: EffectParams;
}

export class EffectStack {
  protected params: EffectStackParams;

  protected effectsInProgress: number;
  protected effectsFinished: number;

  constructor(effectStackParams: EffectStackParams) {
    this.params = effectStackParams;

    this.effectsInProgress = 0;
    this.effectsFinished = 0;
  }

  public showEffects(effectLayer: EffectsLayer) {
    for (let i = 0; i < this.params.targets.length; i++) {
      this.effectsInProgress++;

      let effectParams = Object.assign({}, this.params.effectParams, {
        target: this.params.targets[i],
        endX: this.params.endPoints[i][0],
        endY: this.params.endPoints[i][1],
        baseDuration: 400,
        baseDelay: 0
      });

      this.showEffect(effectLayer, effectParams, 0);
    }
  }

  public showEffect(effectLayer: EffectsLayer, effectParams: EffectParams, effectIndex: number) {
    effectParams.target.setActive(true);
    effectParams.target.setVisible(true);

    let nextEffect = this.params.effects[effectIndex];
    nextEffect.function(nextEffect.params ?? {}, effectParams, () => {
      if (this.hasNextEffect(effectIndex + 1)) {
        this.showEffect(effectLayer, effectParams, effectIndex + 1);
      } else {
        console.log('Effect Finished!');
      }
    });
  }

  protected hasNextEffect(index: number): boolean {
    return index < this.params.effects.length;
  }
}
